import React, { Component } from 'react';
import { connect } from 'react-redux';

import server from "../../api/server";

import { updateVOIData } from "../../actions";

const ICON_USER = (
    <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path
            fillRule="evenodd"
            d="M10 10a4 4 0 100-8 4 4 0 000 8zm-7 8a7 7 0 1114 0H3z"
            clipRule="evenodd"
        />
    </svg>
);

export class VOIBox extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mobile: "",
            disabled: false
        };
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState) {

    }

    startVOI = async (applicant_id, name, identification_id) => {
        this.setState({ disabled: true });
        console.log(this.props.applicant.id, this.props.applicant.name, this.props.VOI.id, this.props.id, 'FLAG2');
        const response = await server.post("/startvoi", { id: this.props.applicant_id, mobile: this.state.mobile, name: this.props.applicant.name, identification_id: this.props.VOI.id, application_id: this.props.id });
        this.props.updateVOIData(response.data);
        this.setState({ disabled: false });
    };

    render() {
        const isDisabled = this.state.disabled == true;
        return (
            <section className="rounded-2xl bg-white shadow-sm border border-[#E5E7EB] p-5 sm:p-6">
                <header className="flex items-start gap-3 mb-4">
                    <span
                        className="inline-flex items-center justify-center h-10 w-10 rounded-xl flex-shrink-0"
                        style={{ backgroundColor: '#EFEAFE', color: '#5B3FE0' }}
                    >
                        {ICON_USER}
                    </span>
                    <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 flex-wrap">
                            <h3 className="text-base sm:text-lg font-bold text-[#1F2937]">
                                {this.props.applicant.name}
                            </h3>
                            <span
                                className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide"
                                style={{ backgroundColor: '#EFEAFE', color: '#5B3FE0' }}
                            >
                                Ready to start
                            </span>
                        </div>
                        <p className="mt-1 text-sm text-[#6B7280] leading-relaxed">
                            Enter your mobile number below. Once you tap Start, you'll
                            receive an SMS with a unique link to finalise the process on
                            your phone.
                        </p>
                    </div>
                </header>

                <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); }}>
                    <div>
                        <label
                            htmlFor={`voi-mobile-${this.props.applicant_id}`}
                            className="block text-sm font-medium text-[#1F2937] mb-2"
                        >
                            Mobile number <span style={{ color: '#DC2626' }}>*</span>
                        </label>
                        <input
                            id={`voi-mobile-${this.props.applicant_id}`}
                            type="tel"
                            inputMode="tel"
                            autoComplete="tel"
                            required
                            value={this.state.mobile}
                            onChange={(e) => { this.setState({ mobile: e.target.value }); }}
                            placeholder="04xx xxx xxx"
                            className="w-full rounded-xl border-2 border-[#E5E7EB] bg-white px-4 py-3 text-base text-[#1F2937] placeholder-[#9CA0AE] focus:outline-none focus:border-[#7C5CFC] transition-colors"
                        />
                    </div>

                    <button
                        type="button"
                        disabled={isDisabled}
                        onClick={() => { this.startVOI(); }}
                        className="w-full sm:w-auto inline-flex items-center justify-center rounded-xl px-6 py-3 text-sm font-semibold text-white shadow-md transition-transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                        style={{ backgroundColor: '#7C5CFC' }}
                    >
                        {isDisabled ? 'Sending…' : 'Start Verification of Identity →'}
                    </button>
                </form>
            </section>
        );
    }
}

const mapStateToProps = (state) => ({
    VOI: state.VOI,
    id: state.id
});

const mapDispatchToProps = {
    updateVOIData
};

export default connect(mapStateToProps, mapDispatchToProps)(VOIBox);
